import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';
import { NgbAccordion, NgbModal, NgbModalConfig, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { PermitProjectFacilityAopService, ProjectFacilityAnnualOperatingPlanApi, ProjectFacilityInstrumentApi } from 'src/app/services/permit-project-facility-aop.service';
import { ProjectFacilitySponsorService, ProjectFacilitySponsorApi } from 'src/app/services/project-facility-sponsor.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PermitProjectFacilityService } from 'src/app/services/permit-project-facility.service';
import { Facility } from 'src/app/services/permit-project-facility.service';
import { ToastrService } from 'ngx-toastr';
import { PermitAopService, PermitAnnualOperatingPlanApi } from 'src/app/services/permit-aop.service';
import { DblistService, ListDeviceRecordingInterval, ListFacilityType, ListPerAcreFootCostBasisForRecharge, ListRecorderType } from 'src/app/services/dblist.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-aop-form',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.25s', keyframes([
          style({ height: 0, opacity: 0, offset: 0 }),
          style({ height: '*', opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, }),
        animate('0.25s', keyframes([
          style({ height: '*', opacity: 1, offset: 0 }),
          style({ height: 0, opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ],
  templateUrl: './aop-form.component.html',
  styleUrls: ['./aop-form.component.scss'],
  providers: [NgbAccordion]
})
export class AopFormComponent implements OnInit {

  @Input() aop: ProjectFacilityAnnualOperatingPlanApi;
  @Input() aopId: number;
  @Input() printMode?: boolean = false;

  @Output() submitEvent = new EventEmitter<boolean>();

  aopInitial: ProjectFacilityAnnualOperatingPlanApi;
  aopData: ProjectFacilityAnnualOperatingPlanApi;
  aopArray: ProjectFacilityAnnualOperatingPlanApi[];
  editMode: boolean = true;
  permitAop: PermitAnnualOperatingPlanApi;
  accArr: string[];
  facilitySponsors: ProjectFacilitySponsorApi[];
  permitSponsors: ProjectFacilitySponsorApi[];

  facilityTypes: ListFacilityType[] = [];
  conversionBasis: ListPerAcreFootCostBasisForRecharge[] = [];
  listRecorderTypes: ListRecorderType[] = [];
  listRecordIntervals: ListDeviceRecordingInterval[] = [];

  typeQtys: instrumentQuantities = {
    1: null,
    2: null,
    3: null,
    4: null
  }

  dropdownSettingsSponsor: IDropdownSettings = {};

  newSelectedSponsors: any[];
  oldSelectedSponsors: any[];

  unsubscribe: Subject<any> = new Subject();

  // FROM PF COMPONENT

  facilities: Facility[];
  selectedProjectFacilityId: number;

  @ViewChild('facilityF', {static: false}) appForm: NgForm;

  // END FROM PF COMPONENT

  constructor(
    private permitAopService: PermitAopService,
    private projectFacilityAopService: PermitProjectFacilityAopService,
    private projectFacilitySponsorService: ProjectFacilitySponsorService,
    private facilityService: PermitProjectFacilityService,
    private dbListService: DblistService,
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal,
    private toastr: ToastrService)
  { modalConfig.backdrop = 'static'; }

  ngOnInit() {
    this.aopInitial = {
      projectFacilityAnnualOperatingPlanId: null, // int
      permitAnnualOperatingPlanId: this.aopId, // int
      projectFacilityId: null, // int
  
      //Location & Capacity Fields (Disabled on UI Populated from the associated facility object
      projectFacilityPermitPointOfDiversionId: null, // int
      projectFacilityListFacilityTypeId: null, // int
      projectFacilityListFacilityTypeName: '', // string
      projectFacilityName: '', // string
      projectFacilityDescription: '', // string
      projectFacilityDeliveryPointLatitude: null, // double
      projectFacilityDeliveryPointLongitude: null, // double
  
      operationalStart: null, // DateTime
      operationalEnd: null, // DateTime
      operationalNarrative: '', // string
      deliveryRate: null, // double
      annualMaxCapacityForAllDiversionsAF: null, // double
      rechargeMaxOperationalHeadFT: null, // double
      rechargeMaxSurfaceAreaSFT: null, // double
      engineeringDrawingsAvailable: false, // bool
  
      // Partners/Sponsors List
      hasSponsors: null,
      projectFacilitySponsorApiList: [] as ProjectFacilitySponsorApi[], // List<ProjectFacilitySponsorApi>
  
      // Instrumentation List
      hasInstrumentation: null,
      projectFacilityInstrumentApiList: [] as ProjectFacilityInstrumentApi[], // List<ProjectFacilityInstrumentApi>
  
      canEdit: true, // bool
    };

    this.aopData = this.aopInitial;

    if (!!this.aop) {
      this.aopData = this.aop;

      if (this.aopData.projectFacilitySponsorApiList === null) {
        this.aopData.projectFacilitySponsorApiList = [] as ProjectFacilitySponsorApi[];
      }

      if (this.aopData.projectFacilityInstrumentApiList === null) {
        this.aopData.projectFacilityInstrumentApiList = [] as ProjectFacilityInstrumentApi[];
      }

      this.aopData.permitAnnualOperatingPlanId = this.aopId;
      this.editMode = false;
    }
    this.buildSponsorData();

    this.dropdownSettingsSponsor = {
      singleSelection: false,
      idField: 'projectFacilitySponsorId',
      textField: 'payingEntityName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      maxHeight: 300,
      itemsShowLimit: 3,
      allowSearchFilter: false,
      defaultOpen: true
    };

    this.projectFacilitySponsorService.aopSponsors$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(sponsors => {
      this.permitSponsors = sponsors;
      if (!this.permitSponsors) {
        this.permitSponsors = [];
      }
    });
    console.log('facility sponsors: ' + this.permitSponsors.length);

    this.countInstrumentIds();

    this.permitAopService.currentAop
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(permitAop => {
      this.permitAop = permitAop;
    });

    this.projectFacilityAopService.currentProjectFacilityAccordion
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(accObj => {
      if (Object.keys(accObj).includes(this.aop.projectFacilityAnnualOperatingPlanId.toString())) {
        this.accArr = accObj[this.aop.projectFacilityAnnualOperatingPlanId];
        if (this.accArr.includes("edit")) {
          this.editMode = true;
        }
      }
    });

    this.facilityService.currentFacilities
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(facilities => {
      this.facilities = facilities;
    });

    this.dbListService.listFacilityType$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(fts => {
      this.facilityTypes = fts;
    });
    this.dbListService.listPerAcreFootCostBasisForRecharge$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(conv => {
      this.conversionBasis = conv;
    });
    this.dbListService.listRecorderType$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(rec => {
      this.listRecorderTypes = rec;
    });
    this.dbListService.listDeviceRecordingInterval$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(ri => {
      this.listRecordIntervals = ri;
    });
  }

  buildSponsorData() {
    this.oldSelectedSponsors = [];
    this.newSelectedSponsors = [];
    if (!!this.aopData) {
      for (let s of this.aopData.projectFacilitySponsorApiList)
      {
        this.oldSelectedSponsors.push(s);
        this.newSelectedSponsors.push(s);
      }
    }
  }

  getSponsorListHeight() {
    return this.permitSponsors.length * 35 + 35;
  }

  submit() {
    this.aopData.projectFacilityAnnualOperatingPlanId = this.aop.projectFacilityAnnualOperatingPlanId;
    //last check for 'hasSponsors'
    if (!(this.aopData.hasSponsors)) {
      this.aopData.projectFacilitySponsorApiList = [];
    }
    this.projectFacilityAopService.putPfaop(this.aopData);
    if (this.editMode) { this.editMode = false; }
  }

  setHasSponsor(yesno: number) {
    if (yesno === 1) {
      this.aopData.hasSponsors = true;
    }
    else if (yesno === 0) {
      this.aopData.hasSponsors = false;
    }
  }

  edit() {
    this.editMode = true;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  listEvent($event) {
    this.aopData[$event.arrayName][$event.index][$event.listName] = $event.listId;
    this.projectFacilityAopService.putPfaop(this.aopData);
    this.editMode = false;
  }

  updateRecorderTypeSelection(i: number, $event) {
    if (!!this.aopData && this.aopData.projectFacilityInstrumentApiList.length> i) {
      var instrument = this.aopData.projectFacilityInstrumentApiList[i];
      for( var j=0; j < this.listRecorderTypes.length; j++ ) {
        if ($event.currentTarget.value == this.listRecorderTypes[j].name) {
          instrument.listRecorderTypeId  = this.listRecorderTypes[j].listRecorderTypeId;
          break;
        }
      }
    }
  }

  updateRecordingInterval(i: number, $event) {
    if (!!this.aopData && this.aopData.projectFacilityInstrumentApiList.length> i) {
      var instrument = this.aopData.projectFacilityInstrumentApiList[i];
      for( var j=0; j < this.listRecordIntervals.length; j++ ) {
        if ($event.currentTarget.value == this.listRecordIntervals[j].interval) {
          instrument.listDeviceRecordingIntervalId  = this.listRecordIntervals[j].listDeviceRecordingIntervalId;
          break;
        }
      }
    }
  }

  generateInstrument(listInstrumentTypeId: number) {
    this.aopData.projectFacilityInstrumentApiList.push(
      {
        // projectFacilityInstrumentId: null,
        projectFacilityAnnualOperatingPlanId: this.aop.projectFacilityAnnualOperatingPlanId,
        listInstrumentTypeId: listInstrumentTypeId,
        listInstrumentTypeName: '',
        name: '',
        locationLatitude: null,
        locationLongitude: null,
        listRecorderTypeId: null,
        listRecorderTypeName: '',
        listDeviceRecordingIntervalId: null,
        listDeviceRecordingIntervalName: '',
        isAvailableToNeDNRLiveDataFeed: null,
        isAvailableToNeDNRStageToSourceTable: null,
        isAvailableToNeDNRAnnualDataSummary: null,    
      }
    );
    this.aopData.projectFacilityInstrumentApiList.sort(this.compare);
    this.countInstrumentId(listInstrumentTypeId);
    switch (listInstrumentTypeId) {
      case 1: this.toastr.success('Added a new Inflow Instrument'); break;
      case 2: this.toastr.success('Added a new Stage Recorder Instrument'); break;
      case 3: this.toastr.success('Added a new Outflow Instrument'); break;
      case 4: this.toastr.success('Added a new Groundwater Monitoring Instrument'); break;
      default: this.toastr.error('Problem adding Instrument'); break;
    }
  }

  compare(a: ProjectFacilityInstrumentApi, b: ProjectFacilityInstrumentApi) {
    const idA = a.listInstrumentTypeId;
    const idB = b.listInstrumentTypeId;
    if (idA > idB) return 1;
    else if (idA < idB) return -1;
    else return 0;
  }

  countInstrumentId(listInstrumentTypeId: number) {
    this.typeQtys[listInstrumentTypeId] = this.aopData.projectFacilityInstrumentApiList.filter(
      instrument => instrument.listInstrumentTypeId === listInstrumentTypeId
    ).length;
  }

  countInstrumentIds() {
    this.countInstrumentId(1);
    this.countInstrumentId(2);
    this.countInstrumentId(3);
    this.countInstrumentId(4);
  }

  removeInstrument(i: number) {
    this.aopData.projectFacilityInstrumentApiList.splice(i,1);
    this.toastr.error('Instrument Removed');
    this.countInstrumentIds();
  }

  beforeChange($event: NgbPanelChangeEvent) {
    this.projectFacilityAopService.changeAccByEvent(this.aop.projectFacilityAnnualOperatingPlanId, $event);
  }

  changeAcc(panel: string, nextState: boolean) {
    this.projectFacilityAopService.changeAcc(this.aop.projectFacilityAnnualOperatingPlanId, panel, nextState);
  }

  changeAccByArr(arr: string[]) {
    this.projectFacilityAopService.changeAccByArr(this.aop.projectFacilityAnnualOperatingPlanId, arr);
  }

  saveLocation() {
    this.changeAccByArr(["outer-panel", "location-panel"]);
    this.submit();
  }

  saveLocationAndClose() {
    this.changeAccByArr(["outer-panel", "partners-panel", "edit"]);
    this.submit();
  }

  savePartners() {
    this.changeAccByArr(["outer-panel", "partners-panel"]);
    this.submit();
  }

  savePartnersAndClose() {
    this.changeAccByArr(["outer-panel", "instrument-panel", "edit"]);
    this.submit();
  }

  saveInstruments() {
    this.changeAccByArr(["outer-panel", "instrument-panel"]);
    this.submit();
  }

  saveInstrumentsAndClose() {
    this.changeAccByArr([]);
    this.submit();
  }

  buildSelectedSponsorsCollection() {
    this.aopData.projectFacilitySponsorApiList = [];
    if (this.newSelectedSponsors.length > 0)
    {
      for (var i=0; i< this.newSelectedSponsors.length; i++)
      {
        let newSponsor: ProjectFacilitySponsorApi = {
          projectFacilitySponsorId: this.newSelectedSponsors[i].projectFacilitySponsorId,
          permitAnnualOperatingPlanId: this.newSelectedSponsors[i].permitAnnualOperatingPlanId,
          payingEntityName: this.newSelectedSponsors[i].payingEntityName,
          listPerAcreFootCostBasisForRechargeId: this.newSelectedSponsors[i].listPerAcreFootCostBasisForRechargeId,
          listPerAcreFootCostBasisForRechargeName: '',
          maxVolumePerYearAF: this.newSelectedSponsors[i].maxVolumePeryearAF,
          contractFileUploadListId: this.newSelectedSponsors[i].contractFileUploadListId,
        }
        this.aopData.projectFacilitySponsorApiList.push(newSponsor);
      }
    }
  }
  
  onItemSelectSponsor(item: any) {
    this.buildSelectedSponsorsCollection();
  }
  onItemDeSelectSponsor(item: any) {
    this.buildSelectedSponsorsCollection();
  }
  onSelectAllSponsor(items: any) {
    this.newSelectedSponsors = [];
    items.forEach((a) => {
      this.newSelectedSponsors.push(a);
    });
    this.buildSelectedSponsorsCollection();
  }

  onDeSelectAllSponsor(items: any) {
    this.newSelectedSponsors = [];
    this.buildSelectedSponsorsCollection();
  }

}

interface instrumentQuantities {
  1: number,
  2: number,
  3: number,
  4: number
}
